// extracted by mini-css-extract-plugin
export default {"wrapper":"pK-z","ratingContainer":"qK-z","ratingValue":"rK-z","starSprite":"sK-z","ratingLabel":"tK-z","error":"uK-z","errorBox":"vK-z"};